import React, { useEffect } from 'react';
import { ClimbingBoxLoader, FadeLoader } from 'react-spinners'
import Card from '../component/Card'
import { useProductContext } from '../providers/ProductProvider'

const Sticker = () => {
  const {stickers,loading}=useProductContext()
  useEffect(()=>{
    window.scrollTo({
        top:0,
        behavior:"smooth"
    })
},[])
  return (
    <div className='container'>
      {
        loading?(
          <div className=' container-fluid d-flex align-items-center justify-content-center '  style={{marginTop:"10%" ,marginBottom:"10%"}}> 
         <FadeLoader color="#ADD8E6" /> <b style={{color:"#ADD8E6"}}> Loading...</b>   
        </div>
        ):(
              <div className='row'>
      {
        stickers?.map((e)=>(
          <Card key={e._id} data={e}/>
          ))
      }
    </div>
        )
      }
            

  </div>
  )
}

export default Sticker
